module.exports = __webpack_public_path__ + "static/img/404.fa626b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/404.png
// module id = 1054
// module chunks = 2